import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { obtenerBookingById } from "../../api";
import { useUser } from "../context/AuthContext";
import { actualizarEstadoReserva } from "../../api";
import Toast from '../components/Toast';

export default function BookingDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { logout } = useUser();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  const [nuevoEstado, setNuevoEstado] = useState(null);
  const [toast, setToast] = useState(null);

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), 3500);
  };

  useEffect(() => {
    obtenerBookingById(id)
      .then((data) => {
        setBooking(data);
        setNuevoEstado(data.state);
      })
      .catch((err) => {
        if (err.response?.status === 401) logout();
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, [id, logout]);

  if (loading) return <div className="p-6 text-white">Loading…</div>;
  if (!booking) return <div className="p-6 text-red-400">Not found</div>;

  return (
    <div className="p-6 bg-[rgb(var(--color-bg))] text-[rgb(var(--color-text))] min-h-screen space-y-6">
      <button className="text-primary" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="flex space-x-6">
        <div className="w-2/3 space-y-6 p-6 bg-hover-bg rounded-lg">
          <h2 className="text-xl font-semibold">Order</h2>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-[rgb(var(--color-text))]/60">Date</label>
              <div className="mt-1">{booking.date.split(",")[0]}</div>
            </div>
            <div>
              <label className="block text-sm text-[rgb(var(--color-text))]/60">Start Time</label>
              <div className="mt-1">{booking.date.split(", ")[1]}</div>
            </div>
            <div>
              <label className="block text-sm text-[rgb(var(--color-text))]/60">End Time</label>
              <div className="mt-1">{booking.endDate.split(", ")[1]}</div>
            </div>
            <div>
              <label className="block text-sm text-[rgb(var(--color-text))]/60">Reference</label>
              <div className="mt-1">{booking.reference}</div>
            </div>
            <div>
              <label className="block text-sm text-[rgb(var(--color-text))]/60">Created At</label>
              <div className="mt-1">{new Date(booking.createdAt).toLocaleString()}</div>
            </div>
            <div>
              <label className="block text-sm text-[rgb(var(--color-text))]/60">Game ID</label>
              <div className="mt-1">{booking.game_id}</div>
            </div>
            <div>
              <label className="block text-sm text-[rgb(var(--color-text))]/60">Status</label>
              <div className="mt-1">
                <span className={`px-2 py-1 rounded text-xs font-medium ${
                  booking.state === 'ordered' ? 'bg-yellow-600 text-yellow-100' :
                  booking.state === 'delivered' ? 'bg-green-600 text-green-100' :
                  'bg-red-600 text-red-100'
                }`}>
                  {booking.state === 'ordered' ? 'Pending' : 
                   booking.state === 'delivered' ? 'Confirmed' : 'Cancelled'}
                </span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Booking Details</h3>
            <div className="bg-white/5 rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-white/10">
                  <tr className="text-[rgb(var(--color-text))]/80">
                    <th className="py-3 px-4 text-left font-medium">Reference</th>
                    <th className="py-3 px-4 text-right font-medium">Unit Price</th>
                    <th className="py-3 px-4 text-right font-medium">Players</th>
                    <th className="py-3 px-4 text-right font-medium">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t border-white/10">
                    <td className="py-4 px-4">
                      <span className="text-primary font-mono font-medium">{booking.reference}</span>
                    </td>
                    <td className="py-4 px-4 text-right font-medium">{booking.total}</td>
                    <td className="py-4 px-4 text-right">
                      <span className="bg-blue-600/20 text-blue-300 px-2 py-1 rounded text-xs font-medium">
                        {booking.items} players
                      </span>
                    </td>
                    <td className="py-4 px-4 text-right font-bold text-green-400">{booking.total}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-hover-bg rounded-lg p-6 border border-[rgb(var(--color-border))]">
            <div className="flex justify-between items-center">
              <div>
                <span className="text-lg font-medium text-[rgb(var(--color-text))]">Total Amount</span>
                <div className="text-xs text-[rgb(var(--color-text))]/60 mt-1">Final booking total</div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-primary">{booking.total}</div>
                <div className="text-xs text-[rgb(var(--color-text))]/60">All inclusive</div>
              </div>
            </div>
          </div>

          <div className="flex space-x-4 mt-4">
            {booking.state === 'ordered' && (
              <>
                <button
                  className="px-4 py-2 bg-green-600 rounded hover:bg-green-700"
                  onClick={async () => {
                    try {
                      await actualizarEstadoReserva(booking.id, 'confirmado');
                      showToast("success", "Booking confirmed");
                      setBooking({...booking, state: 'delivered'});
                    } catch (err) {
                      showToast("error", "Error confirming the booking");
                    }
                  }}
                >
                  Confirm
                </button>
                <button 
                  className="px-4 py-2 bg-red-600 rounded hover:bg-red-700"
                  onClick={async () => {
                    try {
                      await actualizarEstadoReserva(booking.id, 'cancelado');
                      showToast("success", "Booking cancelled");
                      setBooking({...booking, state: 'cancelled'});
                    } catch (err) {
                      showToast("error", "Error cancelling the booking");
                    }
                  }}
                >
                  Cancel
                </button>
              </>
            )}
            
            {booking.state === 'delivered' && (
              <>
                <button 
                  className="px-4 py-2 bg-red-600 rounded hover:bg-red-700"
                  onClick={async () => {
                    try {
                      await actualizarEstadoReserva(booking.id, 'cancelado');
                      showToast("success", "Booking cancelled");
                      setBooking({...booking, state: 'cancelled'});
                    } catch (err) {
                      showToast("error", "Error cancelling the booking");
                    }
                  }}
                >
                  Cancel
                </button>
                <button 
                  className="px-4 py-2 bg-yellow-600 rounded hover:bg-yellow-700"
                  onClick={async () => {
                    try {
                      await actualizarEstadoReserva(booking.id, 'pendiente');
                      showToast("success", "Booking set as pending");
                      setBooking({...booking, state: 'ordered'});
                    } catch (err) {
                      showToast("error", "Error changing status");
                    }
                  }}
                >
                  Set as Pending
                </button>
              </>
            )}
            
            {booking.state === 'cancelled' && (
              <>
                <button
                  className="px-4 py-2 bg-green-600 rounded hover:bg-green-700"
                  onClick={async () => {
                    try {
                      await actualizarEstadoReserva(booking.id, 'confirmado');
                      showToast("success", "Booking confirmed");
                      setBooking({...booking, state: 'delivered'});
                    } catch (err) {
                      showToast("error", "Error confirming the booking");
                    }
                  }}
                >
                  Confirm
                </button>
                <button 
                  className="px-4 py-2 bg-yellow-600 rounded hover:bg-yellow-700"
                  onClick={async () => {
                    try {
                      await actualizarEstadoReserva(booking.id, 'pendiente');
                      showToast("success", "Booking set as pending");
                      setBooking({...booking, state: 'ordered'});
                    } catch (err) {
                      showToast("error", "Error changing status");
                    }
                  }}
                >
                  Set as Pending
                </button>
              </>
            )}
          </div>
        </div>

        <div className="w-1/3 space-y-6 p-6 bg-hover-bg rounded-lg">
          <h2 className="text-xl font-semibold mb-4">Customer</h2>
          
          <div className="space-y-4">
            {/* Customer Name */}
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <div className="font-medium text-[rgb(var(--color-text))]">{booking.client}</div>
                <div className="text-sm text-[rgb(var(--color-text))]/60">Customer Name</div>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </div>
              <div>
                <a href={`mailto:${booking.email}`} className="text-primary hover:underline font-medium">
                  {booking.email}
                </a>
                <div className="text-sm text-[rgb(var(--color-text))]/60">Email Address</div>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
              </div>
              <div>
                <div className="font-medium text-[rgb(var(--color-text))]">{booking.address}</div>
                <div className="text-sm text-[rgb(var(--color-text))]/60">Phone Number</div>
              </div>
            </div>
          </div>
        </div>

        {toast && (
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(null)}
          />
        )}
      </div>
    </div>
  );
}